<template>
	<BaseInput
		v-if="!askBeforeChange"
		ref="BaseInput"
		@click="click"
		v-model="model"
		:label="label"
		:disabled="disabled"
		:error-message="errorMessage"
		:required="required"
		:title="title"
		type="checkbox"
		:class="{ 'pointer-event-none': disabled, 'cursor-pointer': !disabled }"
		:label-class="disabled ? 'text-gray-500' : ''"
	>
		<input type="checkbox" ref="BaseInput" class="shadow-md mr-4" :class="{ '-mt-2': label }" v-model="model" :disabled="disabled" />
	</BaseInput>
	<BaseInput
		v-else
		ref="BaseInput"
		@click.native.prevent="click"
		v-model="model"
		:label="label"
		:disabled="disabled"
		:error-message="errorMessage"
		:required="required"
		:title="title"
		type="checkbox"
		:class="{ 'pointer-event-none': disabled, 'cursor-pointer': !disabled }"
		:label-class="disabled ? 'text-gray-500' : ''"
	>
		<input type="checkbox" ref="BaseInput" class="shadow-md mr-4" :class="{ '-mt-2': label }" v-model="model" :disabled="disabled" />
	</BaseInput>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';

export default {
	name: 'BaseCheckbox',
	components: { BaseInput },
	inheritAttrs: false,
	props: {
		label: {},
		errorMessage: {},
		required: {},
		disabled: {},
		value: {},
		title: { type: String },
		askBeforeChange: { default: false },
		askBeforeChangeQuestion: {
			default: function() {
				return this.$t('change_setting');
			},
		},
		askBeforeChangeErrorBox: { default: false },
		filterOnly: { default: false },
		fontawesomeBeforeLabel: { type: String, default: null },
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				if (!this.filterOnly) {
					this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
				}
				this.$emit('input', v);
			},
		},
	},
	methods: {
		validate() {
			if (this.required) {
				this.$refs.BaseInput.isValid = this.model;
				return this.$refs.BaseInput.isValid;
			}
			return true;
		},
		click() {
			if (!this.askBeforeChange) {
				if (!this.disabled) {
					this.model = !this.model;
					this.$nextTick(() => {
						this.validate();
					});
				}
			} else {
				if (this.askBeforeChangeErrorBox) {
					this.$swal(this.$t('general.attention').toString(), this.askBeforeChangeQuestion, 'warning');
				} else {
					this.$swal({
						title: this.$t('sure').toString(),
						text: this.askBeforeChangeQuestion,
						icon: 'warning',
						cancelButtonText: this.$t('general.no').toString(),
						showCancelButton: true,
						confirmButtonText: this.$t('general.yes').toString(),
					}).then(result => {
						if (result.value) {
							this.$emit('asked');
							this.$nextTick(() => {
								this.validate();
								this.model = !this.model;
							});
						}
					});
				}
			}
		},
	},
};
</script>
